// @flow
import React from 'react';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import Carousel from 'react-bootstrap/Carousel';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
//eslint-disable-next-line
import "./style.scss";

// TODO:
type Props = {
  data: Object,
  theme: string,
};

export const HeroSection = (props: Props) => {
  const { height, isMobile } = useViewport();
  const { data, origin } = props;

  const path = data && data.data.media_path;
  const web = data && data.data.device.web;
  const mobile = data && data.data.device.mobile;
  const thumbnail = data && data.data.device.thumbnail;
  let bannerData = [];
  let videoUrl = null;

  const fetchBannerImageURl = (headerBanner, mobileHeaderBanner) => {
    if (isMobile) {
      return `${path}${mobile}/${mobileHeaderBanner}`;
    }
    return `${path}${web}/${headerBanner}`;
  };

  const fetchThumbNailUrl = (headerBanner, mobileHeaderBanner) => {
    if (isMobile) {
      return `${path}${thumbnail}/${mobileHeaderBanner}`;
    }
    return `${path}${thumbnail}/${headerBanner}`;
  };

  data &&
    data.data.page_banners.map(image => {
      if (image.type === 'Home') {
        videoUrl = image.header_video;
        const sortedData = {
          header_title: image.header_title,
          bannerImageUrl: fetchBannerImageURl(
            image.header_banner,
            image.mobile_header_banner
          ),
          thumbNailUrl: fetchThumbNailUrl(
            image.header_banner,
            image.mobile_header_banner
          ),
        };
        bannerData.push(sortedData);
        if (
          image.header_banner1 &&
          image.header_title1 &&
          image.mobile_header_banner1
        ) {
          const sortedData1 = {
            header_title: image.header_title1,
            bannerImageUrl: fetchBannerImageURl(
              image.header_banner1,
              image.mobile_header_banner1
            ),
            thumbNailUrl: fetchThumbNailUrl(
              image.header_banner1,
              image.mobile_header_banner1
            ),
          };
          bannerData.push(sortedData1);
        }
        if (
          image.header_banner2 &&
          image.header_title2 &&
          image.mobile_header_banner2
        ) {
          const sortedData2 = {
            header_title: image.header_title2,
            bannerImageUrl: fetchBannerImageURl(
              image.header_banner2,
              image.mobile_header_banner2
            ),
            thumbNailUrl: fetchThumbNailUrl(
              image.header_banner2,
              image.mobile_header_banner2
            ),
          };
          bannerData.push(sortedData2);
        }
        if (
          image.header_banner3 &&
          image.header_title3 &&
          image.mobile_header_banner3
        ) {
          const sortedData3 = {
            header_title: image.header_title3,
            bannerImageUrl: fetchBannerImageURl(
              image.header_banner3,
              image.mobile_header_banner3
            ),
            thumbNailUrl: fetchThumbNailUrl(
              image.header_banner3,
              image.mobile_header_banner3
            ),
          };
          bannerData.push(sortedData3);
        }
        if (
          image.header_banner4 &&
          image.header_title4 &&
          image.mobile_header_banner4
        ) {
          const sortedData4 = {
            header_title: image.header_title4,
            bannerImageUrl: fetchBannerImageURl(
              image.header_banner4,
              image.mobile_header_banner4
            ),
            thumbNailUrl: fetchThumbNailUrl(
              image.header_banner4,
              image.mobile_header_banner4
            ),
          };
          bannerData.push(sortedData4);
        }
      } else {
        return null;
      }
    });

  if (origin && origin === 'campaign') {
    data &&
      data.data.page_banners.map(image => {
        if (image.vertical_id === 11) {
          bannerData = [];
          const sortedData = {
            header_title: image.header_title,
            bannerImageUrl: fetchBannerImageURl(
              image.header_banner,
              image.mobile_header_banner
            ),
            thumbNailUrl: fetchThumbNailUrl(
              image.header_banner,
              image.mobile_header_banner
            ),
          };
          bannerData.push(sortedData);
        } else {
          return null;
        }
      });
  }

  let className = 'page-banner';
  const animationClasses = ['animate-height', 'animate-width'];

  return (
    <>
      <Carousel
        className={origin}
        interval={5000}
        pause={false}
        pauseOnHover={false}
        id={'banner'}
      >
        {bannerData.map((banner, idx) => {
          return (
            <Carousel.Item key={idx}>
              <div className={className} style={{ height }}>
                <Banner
                  title={banner.header_title}
                  imageUrl={banner.bannerImageUrl}
                  thumbNailUrl={banner.thumbNailUrl}
                  bannerText={'animate-text'}
                  containerClassName={'intro'}
                  bannerImage={animationClasses.join(' ')}
                  variableWidth={true}
                />
                {isMobile && <FooterExploreButton sectionName={'our-values'} />}
              </div>
            </Carousel.Item>
          );
        })}
      </Carousel>
      {videoUrl && <BannerVideoButton videoUrl={videoUrl} />}
    </>
  );
};

export default HeroSection;
